<template>
    <!-- Offer types -->
    <el-form-item no-help :label="$t('posts.edit.offerType') + ' *'" prop="typeOffre" data-test="post-form-offer-type">
        <el-select
                v-model="post.typeOffre"
                :placeholder="$t('posts.edit.selectTypePlaceholder')"
                clearable
                filterable
                :disabled="desactiverChamp"
        >
            <el-option
                    v-for="offerType in offerTypes"
                    :key="offerType.code"
                    :label="showForSelectLevel(offerType).charAt(0).toUpperCase() + showForSelectLevel(offerType).substr(1)"
                    :value="offerType.code"
            >
            </el-option>
        </el-select>
    </el-form-item>
</template>

<script>
import _each from 'lodash/each'
import { mapGetters } from 'vuex'
import { getOfferTypes } from '@/services/postsData'

export default {
  name: 'PostFormOfferType',
  props: ['post', 'desactiverChamp'],
  data: function () {
    return {
      offerTypes: []
    }
  },
  computed: {
    ...mapGetters(['getOfferTypes'])
  },
  async beforeMount () {
    let results = this.getOfferTypes
    if (!results || results.length === 0) {
      results = await getOfferTypes()
    }
    if (!results || results.length === 0) {
      return
    }
    const tab = []
    const tab2 = []
    _each(results, function (object) {
      if (object.code == 'V') {
        tab.push(object)
      }
    })
    _each(results, function (object) {
      if (object.code == 'L') {
        tab.push(object)
      } else if (object.code == 'V') {

      } else {
        tab2.push(object)
      }
    })

    const tabFinal = tab.concat(tab2)
    this.offerTypes = tabFinal
  },
  methods: {
    showForSelectLevel (offerType) {
      return '\xa0'.repeat(offerType.niveau * 3) + offerType.libelle
    }
  }
}
</script>
